import React from 'react';
import Header from '../Componentes/header'
import Footer from '../Componentes/footer'
import { Button, Form, FormGroup, Input, FormFeedback } from 'reactstrap'
import history from '../historial'
import { toast } from 'react-toastify';
import Fetch from '../Auxiliares/fetch'

export default class InicioSesion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            usuario: '',
            contraseña: '',
            errors: {}
        };

        this.setItem = this.setItem.bind(this);
    }
    
    setItem = (key, value) => {
        return Promise.resolve().then(function () {
            localStorage.setItem(key, value);
            Fetch('/api/auth', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            })
                .then(response => {
                    const data = response.data;
                    return Promise.resolve().then(function () {
                        sessionStorage.setItem('_id', data._id);
                        sessionStorage.setItem('nombre', data.nombre);
                        sessionStorage.setItem('ap_paterno', data.ap_paterno);
                        sessionStorage.setItem('ap_materno', data.ap_materno);
                        sessionStorage.setItem('rol', data.rol);
                        sessionStorage.setItem('usuario', data.usuario);
                        sessionStorage.setItem('grupo', data.grupo)
                        history.push('/inicio')
                    })
                })
                .catch(err => {
                    switch (err.status) {
                        case 401:
                            toast.error('Esta sesion ha caducado')
                            break;

                        case 600:
                            toast.error('Error inesperado')
                            break;

                        case 602:
                            toast.error('Usuario no encontrado')
                            break;

                        default:
                            toast.error(err)
                            break;
                    }
                })
        });
    }

    iniciarSesion = (e) => {
        e.preventDefault();

        let errors = {}
        const { usuario, contraseña } = this.state

        if (!usuario) errors.usuario = "Usuario no ingresado"
        if (!contraseña) errors.contraseña = "Contraseña no ingresada"
            
        this.setState({ errors })
        
        if (Object.keys(errors).length === 0) {
            Fetch('/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ usuario, contraseña })
            })
                .then(response => {
                    if (response.status === 700) {
                        response.json().then(newResponse => {
                            localStorage.setItem('id', newResponse.id)
                            history.push('/primerInicio')
                        });
                    } else {
                        this.setItem('token', response.token)
                    }
                })
                .catch(err => {
                    switch (err.status) {
                        case 602:
                            toast.error('Usuario no existente')
                            break;
                        case 603:
                            toast.error('Contraseña incorrecta')
                            break;
                        case 606:
                            toast.info('Esta cuenta sigue en espera de ser autorizada, contacte al administrador')
                            break;
                        case 608:
                            toast.warn('Esta cuenta ha sido desactivada, contacte al administrador')
                            break;
                        default:
                            break
                    }
                })
        }
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value })
    }

    setValueNumber(field, ev) {
        this.setState({ [field]: Number(ev.target.value) })
    }

    render() {
        return (
            <html>
                <Header />
                <div className="container">
                    <div className="form-page">
                        <div className="form">
                            <Form className="login-form" method="post" encType="multipart/form-data" onSubmit={this.iniciarSesion}>
                                <div className="container">
                                    <br></br>
                                    <FormGroup>
                                        <Input type="text" onChange={this.setValue.bind(this, "usuario")} 
                                        invalid={this.state.errors.usuario} placeholder="Usuario" name="usuario" />
                                        <FormFeedback>{this.state.errors.usuario}</FormFeedback>
                                    </FormGroup>

                                    <FormGroup>
                                        <Input type="password" onChange={this.setValue.bind(this, "contraseña")} 
                                        invalid={this.state.errors.contraseña} placeholder="Contraseña" name="pass" />
                                        <FormFeedback>{this.state.errors.contraseña}</FormFeedback>
                                    </FormGroup>

                                    <Button className="bg-info" style={{width:"90%"}}>Iniciar Sesión</Button>
                                    <p className="message">¿No registrado? <a href="/registro" className="text-info" >Crear una cuenta</a></p>
                                    <p className="message">¿Eres aspirante? <a href="/aspiranteSesion" className="text-info" >Entrar como aspirante</a></p>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
                <Footer />
            </html>
        )
    }
}
